import axiosInstance from "../variables/api/axiosInstance";

export const modulesService = {
    /** Liste tous les modules actifs (lecture seule) */
    list: () => axiosInstance.get('/v1/modules'),
};